module.exports = __webpack_public_path__ + "img/25a24cd.jpg";